/**
 * @generated SignedSource<<8b57b09e01e926b182b9df47d6ba5eb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "updateProfileLanguage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeLanguageFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeLanguageFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4f16c532e8c2c749ad9baf661fda7c4d",
    "id": null,
    "metadata": {},
    "name": "ChangeLanguageFormMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeLanguageFormMutation(\n  $input: UpdateProfileLanguageInput!\n) {\n  updateProfileLanguage(input: $input) {\n    id\n    language\n  }\n}\n"
  }
};
})();

node.hash = "181cc054935b78627e8b36f547d39ab4";

module.exports = node;
